/**
 * @generated SignedSource<<dde6ba99fb81cfed6139f02f6efc55cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateAADOauthKeyInput = {
  email?: string | null;
  issuer?: string | null;
  mobileAppUrl?: string | null;
  clientMutationId?: string | null;
};
export type createAADOauthKeyMutation$variables = {
  input: CreateAADOauthKeyInput;
};
export type createAADOauthKeyMutation$data = {
  readonly createAADOauthKey: {
    readonly key: string | null;
    readonly AADClientId: string | null;
    readonly AADTenant: string | null;
  } | null;
};
export type createAADOauthKeyMutation = {
  variables: createAADOauthKeyMutation$variables;
  response: createAADOauthKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAADOauthKeyPayload",
    "kind": "LinkedField",
    "name": "createAADOauthKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "AADClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "AADTenant",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createAADOauthKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createAADOauthKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2a56f52857f7b9e76b927a7471d3c12",
    "id": null,
    "metadata": {},
    "name": "createAADOauthKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createAADOauthKeyMutation(\n  $input: CreateAADOauthKeyInput!\n) {\n  createAADOauthKey(input: $input) {\n    key\n    AADClientId\n    AADTenant\n  }\n}\n"
  }
};
})();

(node as any).hash = "568b9266eafbce3d9d29e3634a15b9fb";

export default node;
